import { getFavoriteSongIds as fetchFavoriteSongIds } from "@/lib/firebase/firestore";
import {
  getCachedFavoriteIds,
  setCachedFavoriteIds,
} from "@/lib/firebase/session-cache";
import { waitForAuthToken } from "@/lib/firebase/wait-for-auth";

/** Read cached ids only (no network). */
export function peekCachedFavoriteIds(uid: string): string[] | null {
  return getCachedFavoriteIds(uid);
}

/** Fetch from Firestore and update cache; keeps cache on transient failures. */
export async function refreshFavoriteSongIds(uid: string): Promise<string[]> {
  const previous = getCachedFavoriteIds(uid) ?? [];

  try {
    await waitForAuthToken();
    const ids = await fetchFavoriteSongIds(uid);

    if (ids.length === 0 && previous.length > 0) {
      await waitForAuthToken(4000);
      const retry = await fetchFavoriteSongIds(uid);
      if (retry.length > 0) {
        setCachedFavoriteIds(uid, retry);
        return retry;
      }
      return previous;
    }

    setCachedFavoriteIds(uid, ids);
    return ids;
  } catch {
    return previous;
  }
}

/** Network read; use {@link peekCachedFavoriteIds} for instant UI. */
export async function getFavoriteSongIds(uid: string): Promise<string[]> {
  return refreshFavoriteSongIds(uid);
}
